var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('v-head'),_c('div',{staticClass:"bottomBox"},[_c('sidebar',{staticClass:"left"}),_c('app-main',{staticClass:"right"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }